import React from 'react';
import PropTypes from 'prop-types';

import Fare from '../../records/Fare';
import OrderFare from '../../records/order/Fare';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import { getFareRefundDetailsMessageKey } from '../../helpers/RefundCopy';
import { shouldUseUpdatedRefundCopy } from '../account/refund/refundCopyUtils';

function FareRefundsInfo({ fare, small }) {
    const refundTextMessage = getFareRefundDetailsMessageKey(fare, small && shouldUseUpdatedRefundCopy(fare));

    return (
        <FormattedHTMLMessage
            message={refundTextMessage}
            className={`margin-top--sm ${small ? 'text-sm' : ''}`}
            tagName="p"
        />
    );
}

FareRefundsInfo.propTypes = {
    fare: PropTypes.oneOfType([PropTypes.instanceOf(Fare), PropTypes.instanceOf(OrderFare)])
        .isRequired,
    small: PropTypes.bool,
};

export default FareRefundsInfo;
